import React, { useContext, useState } from "react";
import {
  Container,
  TextField,
  Button,
  Card,
  CardContent,
  Typography,
  Box,
} from "@mui/material";
import { LangContext } from "../LanguageProvider";
import useAuthStore from "../services/AuthStore";
import { useNavigate } from "react-router-dom";

export default function Login() {
  const { translations } = useContext(LangContext);
  const navigate = useNavigate();
  const { login } = useAuthStore();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async e => {
    e.preventDefault();
    // Add logic for authentication here
    if (username === "" || password === "") {
      setError("Пожалуйста, заполните все поля.");
    } else {
      setError("");
      // Logic for submitting login information
      console.log("Logging in with:", { username, password });
      const result = await login(username, password);
      if (result) {
        navigate("/");
      } else {
        setError("Не правильный логин или пароль");
      }
    }
  };

  return (
    <Container maxWidth="sm" sx={{ marginTop: 8 }}>
      <Card>
        <CardContent>
          <Typography variant="h4" align="center" gutterBottom>
            {translations["login_btn_text"]}
          </Typography>
          <Box component="form" onSubmit={handleSubmit} sx={{ mt: 3 }}>
            <TextField
              fullWidth
              label={translations["username"]}
              variant="outlined"
              margin="normal"
              type="username"
              value={username}
              onChange={e => setUsername(e.target.value)}
            />
            <TextField
              fullWidth
              label={translations["password"]}
              variant="outlined"
              margin="normal"
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
            />
            {error && (
              <Typography
                variant="body2"
                color="error"
                align="center"
                sx={{ mt: 2 }}>
                {error}
              </Typography>
            )}
            <Button
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
              sx={{ mt: 3 }}>
              {translations["login_text"]}
            </Button>
          </Box>
        </CardContent>
      </Card>
    </Container>
  );
}
